module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-36.27527c5d.png";